import type { Currency } from '../../../constants';

export type CreatePaymentIntentRequest = {
  amount: number;
  currency: Currency;
  description?: string;
  receiptEmail?: string;
  metadata?: Record<string, string>;
};
export type UpdatePaymentIntentRequest = {
  stripePaymentIntentId: string;
  amount: number;
  currency: Currency;
  customer?: string;
  description?: string;
  receiptEmail?: string;
  paymentMethod?: string;
  metadata?: Record<string, string>;
};

export type CreatePaymentIntentResponse = {
  id: string;
  clientSecret: string;
  status: string;
  amount: number;
  currency: string;
};

export type UpdatePaymentIntentResponse = {
  id: string;
  clientSecret: string;
  status: string;
  amount: number;
  currency: string;
};

export const PAYPAL_ORDER_STATUS = {
  Created: 'CREATED',
  Completed: 'COMPLETED',
  Pending: 'PENDING',
  Failed: 'FAILED',
} as const;

export type PaypalOrderStatus = (typeof PAYPAL_ORDER_STATUS)[keyof typeof PAYPAL_ORDER_STATUS];

export interface CreatePaypalOrderRequest {
  wooCommerceOrderId: string;
  orderKey: string;
}

export interface CreatePaypalOrderResponse {
  wooCommerceOrderId: string;
  paypalOrderId: string;
  status: typeof PAYPAL_ORDER_STATUS.Created;
}

export interface CapturePaypalOrderRequest extends CreatePaypalOrderRequest {
  paypalOrderId: string;
}

export interface CapturePaypalOrderResponse {
  wooCommerceOrderId: string;
  paypalOrderId: string;
  captureId: string | null;
  status: Exclude<PaypalOrderStatus, typeof PAYPAL_ORDER_STATUS.Created>;
}

interface PaypalRecoveryResponseBase {
  wooCommerceOrderId: string;
  paypalOrderId: string;
  captureId: string | null;
}

export interface CreatedPaypalRecoveryResponse extends PaypalRecoveryResponseBase {
  status: typeof PAYPAL_ORDER_STATUS.Created;
  confirmationEmail?: never;
}

export interface PendingPaypalRecoveryResponse extends PaypalRecoveryResponseBase {
  status: typeof PAYPAL_ORDER_STATUS.Pending;
  confirmationEmail?: never;
}

export interface FailedPaypalRecoveryResponse extends PaypalRecoveryResponseBase {
  status: typeof PAYPAL_ORDER_STATUS.Failed;
  confirmationEmail?: never;
}

export interface CompletedPaypalRecoveryResponse extends PaypalRecoveryResponseBase {
  status: typeof PAYPAL_ORDER_STATUS.Completed;
}

export type PaypalRecoveryResponse =
  | CreatedPaypalRecoveryResponse
  | PendingPaypalRecoveryResponse
  | FailedPaypalRecoveryResponse
  | CompletedPaypalRecoveryResponse;
